var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d33119ba-ba94-4b91-b785-6056f5008046"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "3588f078-fabc-465c-85fb-c3e3a8384d8c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33 0 0 1.33 570.73 419.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-310, -248)",
    d: "M 285.2 35.588 C 215.945 43.567 166.07999999999998 106.28200000000001 166.15999999999997 158.702 C 166.15999999999997 181.921 165.92799999999997 199.96699999999998 166.15999999999997 223.183 C 166.87699999999998 257.335 159.25399999999996 303.585 141.35999999999996 332.303 C 138.56099999999995 336.701 133.55399999999995 342.167 126.34099999999995 348.699 C 120.11265401282999 354.34014548896397 116.55981650435169 362.3517377685875 116.55999999999995 370.755 L 116.55999999999995 391.825 C 116.55999999999995 400.042 123.22099999999995 406.702 131.43699999999995 406.702 L 488.55699999999996 406.702 C 496.77399999999994 406.702 503.43399999999997 400.041 503.43399999999997 391.825 L 503.43399999999997 370.755 C 503.4343087406135 362.3517112454106 499.8814497247822 354.3400704670469 493.65299999999996 348.699 C 486.43899999999996 342.16700000000003 481.43299999999994 336.7 478.63399999999996 332.303 C 460.73999999999995 303.586 453.11699999999996 257.335 453.83399999999995 223.183 C 454.066 199.968 453.83399999999995 181.921 453.83399999999995 158.702 C 453.91399999999993 106.285 404.05099999999993 43.568 334.7939999999999 35.587999999999994 L 334.7939999999999 24.8 C 334.7939999999999 8.265 326.52899999999994 0 309.9939999999999 0 C 293.4589999999999 0 285.1939999999999 8.265 285.1939999999999 24.8 z M 310 496 C 268.911 496 235.6 462.689 235.6 421.6 L 384.4 421.6 C 384.4 462.689 351.089 496 310 496 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellWhite);
export default __webpack_public_path__ + "static/media/bell-white.05f87bcff65af4ccdac1879a41feba36.svg";
export { ForwardRef as ReactComponent };